import React, {forwardRef} from 'react';
import Box from "@mui/material/Box";
import PrimaryButton from "../Components/Buttons/PrimaryButton";
import ProfileImage from "../../Images/Profil-1.jpg";
import "./FrontPage.css";
import {contentTexts} from "../ContentText";
import {useMediaQuery, useTheme} from "@mui/material";

const FrontPage = forwardRef(({talk_ref}, ref) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        !isMobile ? (
                <Box sx={{width: "100%", height: "830px"}} ref={ref} className={"frontpage-container"}>
                    <Box className={"front-page-title"} sx={{display: "flex", flexDirection: "column"}}>
                        <p className="header-font">
                            {contentTexts.topTitlePageSlogan}
                        </p>
                        <Box sx={{marginLeft: "120px"}}>
                            <p className="header-font">
                                {contentTexts.bottomTitlePageSlogan}
                            </p>
                        </Box>
                        <Box sx={{marginBottom: "52px"}}>
                            <p className="subtitle-title-page">
                                {contentTexts.subtitleTitlePageSlogan}
                            </p>
                        </Box>
                        <PrimaryButton className={"titlepage-button"} onClick={() => (talk_ref.current?.scrollIntoView({behavior: 'smooth'}))}>
                            {contentTexts.titlePageButton}
                        </PrimaryButton>
                    </Box>
                    <img src={ProfileImage} alt={"Image for titlepage"} className={"centered-element"}
                         height={"100%"}/>
                </Box>) :
            (
                <Box sx={{
                    paddingTop: "40px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                }}
                     ref={ref}>
                    <Box className={"flexColumnCenter"}>
                        <Box>
                            <p className="header-font-mobile">
                                {contentTexts.topTitlePageSlogan}
                            </p>
                            <Box sx={{marginLeft: "18vw"}}>
                                <p className="header-font-mobile">
                                    {contentTexts.bottomTitlePageSlogan}
                                </p>
                            </Box>
                        </Box>
                        <Box sx={{marginBottom: "52px"}}>
                            <p className="subtitle-title-page-mobile">
                                {contentTexts.subtitleTitlePageSlogan}
                            </p>
                        </Box>
                        <PrimaryButton style={{width: "80%"}}
                                       onClick={() => (talk_ref.current?.scrollIntoView({behavior: 'smooth'}))}
                        >
                            {contentTexts.titlePageButton}
                        </PrimaryButton>
                    </Box>

                    <Box sx={{
                        height: '600px',
                        display: 'flex',           // make it a flex container
                        justifyContent: 'center',  // center horizontally
                        alignItems: 'center',      // center vertically
                    }}>
                        <Box
                            component="img"
                            src={ProfileImage}
                            alt="Image for titlepage"
                            sx={{
                                height: '100%',
                                width: 'auto',
                                transform: 'translateX(-40px)',  // shift 10px left
                            }}
                        />
                    </Box>

                </Box>
            )

    );
});

export default FrontPage;